import { render, staticRenderFns } from "./perturbedgene.vue?vue&type=template&id=03511bc0&"
import script from "./perturbedgene.vue?vue&type=script&lang=js&"
export * from "./perturbedgene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports